import React, { useEffect } from 'react'
import ApproacheDetails from '../../Components/ApproacheDetails/ApproacheDetails'
import styles from './Approach.module.css'
import Contact from "../../Components/Contact/Contact"
import AnimiatedPage from '../../AnimiatedPage'

function Approach() {
    useEffect(()=>{
        document.title = 'SHARVIL Business Group -Approaches'
        },[])
    return (
        <AnimiatedPage>
            <div className={styles.Approach}>
                <div className={styles.whyusHead}>
                    <h3 style={{ color: '#066263' }}>プロジェクトの流れ <span>APPROACH</span></h3>
                </div>
                <ApproacheDetails />
                <Contact />
            </div>
        </AnimiatedPage>
    )
}

export default Approach